'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import { validatePhone, validatePhoneErrorMessage } from '../validators'
import MaskedField, { MaskedFieldProps } from './masked-field'

/* -----------------------------------------------------------------------------
 * PhoneField
 * -------------------------------------------------------------------------- */

export type PhoneFieldProps = Omit<
  MaskedFieldProps,
  'label' | 'nativeMask' | 'webMask'
> & {
  label?: MaskedFieldProps['label']
}

const PhoneField = ({ required, ...props }: PhoneFieldProps) => {
  const requiredVal =
    required && typeof required === 'boolean'
      ? validatePhoneErrorMessage
      : required

  return (
    <MaskedField
      label='Phone Number'
      placeholder='800-555-5555'
      nativeMask='[000]-[000]-[0000]'
      webMask={[
        /[1-9]/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      validate={validatePhone()}
      required={requiredVal}
      autoCompleteType='tel'
      textContentType='telephoneNumber'
      {...props}
    />
  )
}

export default PhoneField
